import { Visibility } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

interface ViewWalletButtonProps {
  walletId: number;
}

export function ViewWalletButton({ walletId }: ViewWalletButtonProps) {
  const goToWallet = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    window.open(`/monitor/wallet/${walletId}`, '_blank');
  };

  return (
    <Tooltip title="Ver carteira" arrow>
      <IconButton
        color="primary"
        onClick={goToWallet}
        sx={{
          flexShrink: 0,
          borderRadius: 2,
          border: 2,
          p: 1.5,
          borderColor: 'divider',
          transition: 'border-color 150ms',
          '&:hover': {
            borderColor: 'primary.main',
          },
        }}>
        <Visibility />
      </IconButton>
    </Tooltip>
  );
}
